module.exports = __webpack_public_path__ + "img/symbol_4.580a0ddb.png";